/**
 * @file ページの先頭に戻るボタンのコンポーネント
 */
import React, { useState, useEffect } from "react";
import "./GoToTopButton.css";

/**
 * ページの先頭に戻るボタン
 * @returns {JSX.Element} ページの先頭に戻るボタンのJSX要素
 */
export function GoToTopButton(): JSX.Element {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > window.innerHeight / 4) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`p-page-top ${isVisible ? "" : "p-page-top--hide"}`}
      style={{
        display: isVisible ? "block" : "none",
      }}
      title="ページの先頭へ戻る"
    ></button>
  );
}
